import { html, LitElement } from 'lit';
import Styles from './vm-icon.scss';

export default class VmIcon extends LitElement {
    static styles = Styles;

    static properties = {
        name: { type: String },
    };

    render() {
        return html`<i class="icon icon-${this.name}"></i>`;
    }
}

customElements.define('vm-icon', VmIcon);
